import { render, staticRenderFns } from "./GastosEnvioOnline.vue?vue&type=template&id=dd85521c&scoped=true"
import script from "./GastosEnvioOnline.vue?vue&type=script&lang=js"
export * from "./GastosEnvioOnline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd85521c",
  null
  
)

export default component.exports